import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import * as applicationConstants from '@app/constants/application-constants';
import * as fromApp from '@app/store/app.reducers';
import { getLoggedIn, getLoggedInContact, getLoggedOut, getProfile } from '@app/store/app.reducers';
import { AuthService } from '@app/services/auth.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { getLoadingContact } from '@app/store/app.reducers';
import { map } from 'rxjs/operators';
import { MenuLinksService } from '@app/services/menu-links.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

    @Output() onSiderClick = new EventEmitter();

    isLoggedIn$: Observable<boolean>;
    isLoggedOut$: Observable<boolean>;

    applicationConstants: any;
    menuLinks$: Observable<any[]>;
    profile$: Observable<{
        name: string;
        email: string;
    }>;

    constructor(
        private store: Store<fromApp.AppState>,
        public auth: AuthService,
        private menuLinksService: MenuLinksService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.menuLinks$ = this.menuLinksService.menuLinks$;

        this.isLoggedIn$ = this.store.select(getLoggedIn);
        this.isLoggedOut$ = this.store.select(getLoggedOut);

        this.profile$ = combineLatest([
            this.store.select(getProfile),
            this.store.select(getLoadingContact),
            this.store.select(getLoggedInContact)
        ]).pipe(
            map(([profile, isLoadingContact, loggedInContact]) => {
                let result = null;

                if (!!profile) {
                    if (!isLoadingContact && !!loggedInContact) {
                        result = {
                            name: loggedInContact.firstName + ' ' + loggedInContact.lastName,
                            email: profile.email
                        };
                    } else {
                        result = {
                            name: profile.name,
                            email: profile.email
                        };
                    }
                }

                return result;
            })
        );
    }

    onLogin() {
        localStorage.setItem('auth-entry-url', '/catalogue/category');
        this.router.navigate(['/account/login']);
    }

    onCreateAccount() {
        this.router.navigate(['account', 'create']);
    }

    onLogout() {
        this.auth.logout();
    }

    onProfile() {
        this.router.navigate(['profile']);
    }

    onItemClick() {
        this.onSiderClick.emit();
    }
}
